import React, { useMemo } from 'react';
import { ErrorMessage } from 'formik';
import Autosuggest from 'react-autosuggest';
import { useTranslation } from 'react-i18next';
import { GeneralQuestionnaire } from '../../shared/GeneralQuestionnaire';

const visitorTerminalFontSize = {
  fontSize: '1.5rem !important',
};

// const autosuggestTheme = {
//   container: {
//     position: 'relative',
//   },
//   input: {
//     fontFamily: 'Helvetica, sans-serif',
//     fontSize: '1.5rem',
//     color: 'red',
//     border: '1px solid #aaa',
//     borderRadius: '5px',
//   },
//   inputFocused: {
//     outline: 'none',
//   },
//   inputOpen: {
//     borderBottomLeftRadius: 0,
//     borderBottomRightRadius: 0,
//   },
//   suggestionsContainer: {
//     display: 'none',
//     color: 'red',

//   },
//   suggestionsContainerOpen: {
//     display: 'block',
//     position: 'absolute',
//     top: 51,
//     width: 280,
//     border: '1px solid #aaa',
//     backgroundColor: '#fff',
//     fontFamily: 'Helvetica, sans-serif',
//     color: 'red',
//     fontWeight: 300,
//     fontSize: 16,
//     borderBottomLeftRadius: 4,
//     borderBottomRightRadius: 4,
//     zIndex: 2,
//   },
//   suggestionsList: {
//     margin: 0,
//     padding: 0,
//     listStyleType: 'none',
//     color: 'red',
//   },
//   suggestion: {
//     cursor: 'pointer',
//     padding: '10px 20px',
//     color: 'green',
//   },
//   suggestionHighlighted: {
//     backgroundColor: '#ddd',
//     color: 'green',
//   },
// };

export default function VisitorTerminalTemplate(props) {
  const [text, setText] = React.useState('');
  const suggestedHosts = useMemo(() => {
    const inputValue = text.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : props.hosts.filter((host) => host.name.toLowerCase().slice(0, inputLength) === inputValue);
  }, [props.hosts, text]);

  const { t } = useTranslation();

  const {
    handleChange,
    handleBlur,
    values,
    errors,
    touched,

    // suggestedHosts,
    // onSuggestionsFetchRequested,
    // onSuggestionsClearRequested,
    // getSuggestionValue,
    // onSuggestionChange,
    setFieldValue,
    // renderSuggestion,
    // renderInputComponent,

    selectedVisitorType,
    filteredQuestions,
    showHostError,
    isSubmitting,
    onPrevClick,
    hosts,
    onHostChanged,
    displayCompany,
    questionsEnabled,
    isEnableIfThenQuestionnaire,
  } = props;

  React.useEffect(() => {}, []);

  const renderInputComponent = (inputProps) => (
    <>
      <input id="nameOfHost" name="nameOfHost" type="text" {...inputProps} />
      {/* <ErrorMessage className="text-gray-300 text-xl italic" component="p" name="nameOfHost" /> */}
    </>
  );

  // const getSuggestions = (value) => {
  //   const inputValue = value.trim().toLowerCase();
  //   const inputLength = inputValue.length;

  //   return inputLength === 0 ? [] : hosts.filter((host) => host.name.toLowerCase().slice(0, inputLength) === inputValue);
  // };

  const getSuggestionValue = (suggestion) => suggestion.name;

  const renderSuggestion = (suggestion) => (
    <div className="bg-white border border-gray-400 p-3">
      {/* <div className="divide-y divide-blue-300"> */}
      <span className="text-lg truncate text-gray-800">{suggestion.name}</span>
      {/* </div> */}
    </div>
  );

  const onSuggestionChange = (event, suggestionProps, setFieldValue) => {
    setFieldValue('nameOfHost', suggestionProps.suggestionValue);
    const [hostDetails] = hosts.filter((item) => item.name === suggestionProps.suggestionValue);
    // console.log('hostDetails', hostDetails);

    onHostChanged(hostDetails);
    // setStateSugestions({
    //   ...stateSugestions,
    //   selectedHost: suggestionProps.suggestionValue,
    //   selectedHostDetails: hostDetails,
    // });
    // console.log('onSuggestionChange', stateSugestions);
  };

  // const onSuggestionsFetchRequested = ({ value }) => {
  //   setStateSugestions({
  //     ...stateSugestions,
  //     suggestions: getSuggestions(value),
  //   });
  //   console.log('onSuggestionsFetchRequested', stateSugestions);
  // };

  // const onSuggestionsClearRequested = () => {
  //   setStateSugestions({
  //     ...stateSugestions,
  //     suggestedHosts: [],
  //   });
  //   console.log('onSuggestionsClearRequested', stateSugestions);
  // };

  return (
    <>
      <div className={'questionPart'}>
        <h1 className="mt-4 text-3xl font-bold text-center">{t('Tell us about yourself')}</h1>
        <br />
        <div className="mb-4">
          <label className="block font-bold mb-2" htmlFor="name">
            {t('Name')}
          </label>
          <input
            className={`shadow appearance-none border-4 rounded w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
              errors.name && touched.name ? 'border-red-500' : ''
            }`}
            id="name"
            name="name"
            type="text"
            placeholder={t('Name')}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.name}
            autoComplete="off"
          />
          {/* <ErrorMessage className="text-gray-300 text-xl italic" component="p" name="name" /> */}
        </div>

        {/* {displayCompany && (
          <div className="mb-4">
            <label className="block text-white text-lg font-bold mb-2" htmlFor="email">
              Email
            </label>
            <input
              className={`shadow appearance-none border-4 w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.email && touched.email ? 'border-red-500' : ''
              }`}
              id="email"
              name="email"
              type="email"
              placeholder="Email address"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
            />
            <ErrorMessage className="text-gray-300 text-xl italic" component="p" name="email" />
          </div>
        )} */}

        {displayCompany && (
          <div className="mb-4">
            <label className="block font-bold mb-2" htmlFor="company">
              {t('Company')}
            </label>
            <input
              className={`shadow appearance-none border-4 rounded w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.company && touched.company ? 'border-red-500' : ''
              }`}
              id="company"
              name="company"
              type="text"
              placeholder={t('Company')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.company}
              autoComplete="off"
            />
            <ErrorMessage className="text-gray-300 text-xl italic" component="p" name="company" />
          </div>
        )}
      </div>

      {
        <div className={'questionPart'}>
          <h1 className="mt-4 text-3xl font-bold text-center">{t('Who are you visiting')}?</h1>
          <br />
          <div className="mb-4">
            <label className="block font-bold mb-2" htmlFor="nameOfHost">
              {t('Name of host')}
            </label>

            <Autosuggest
              // theme={autosuggestTheme}
              suggestions={suggestedHosts}
              onSuggestionsFetchRequested={({ value }) => setText(value)}
              onSuggestionsClearRequested={() => setText('')}
              getSuggestionValue={getSuggestionValue}
              // onSuggestionSelected={() => onSuggestionChange(setFieldValue)}
              onSuggestionSelected={(event, data) => {
                onSuggestionChange(event, data, setFieldValue);
              }}
              renderSuggestion={renderSuggestion}
              renderInputComponent={renderInputComponent}
              focusInputOnSuggestionClick={true}
              inputProps={{
                id: 'nameOfHost',
                name: 'nameOfHost',
                placeholder: t('Type and select the host name'),
                value: values.nameOfHost,
                onBlur: handleBlur,
                onChange: handleChange,
                className: `shadow appearance-none border-4 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.nameOfHost && touched.nameOfHost ? 'border-red-500 ' : ''
                }`,
              }}
            />
          </div>
          {showHostError && (
            <div className="text-gray-300 text-xl italic text-center">{t('We did not find the name of the person you’re looking for, please enter a valid name')}</div>
          )}
        </div>
      }

      {questionsEnabled && (
        <GeneralQuestionnaire
          selectedVisitorType={selectedVisitorType}
          onChange={handleChange}
          filteredQuestions={filteredQuestions}
          errors={errors}
          touched={touched}
          values={values}
          pagination={true}
          fontSize={visitorTerminalFontSize}
          isEnableIfThenQuestionnaire={isEnableIfThenQuestionnaire}
        />
      )}

      <div className={'questionPart'}>
        <img className="visitor-picture-preview" alt="" />
        <div className={'description'}>
          <div className={'descriptionBlock'}>
            <div className={'descriptionTitle'}>{t('I am')}</div>
            <div className={'descriptionValue'}>{values.entryType}</div>
          </div>
          <div className={'descriptionBlock'}>
            <div className={'descriptionTitle text-xl'}>{t('My name is')}</div>
            <div className={'descriptionValue'}>{values.name}</div>
          </div>
          {values.company && (
            <div className={'descriptionBlock'}>
              <div className={'descriptionTitle'}>{t('I am from')}</div>
              <div className={'descriptionValue'}>{values.company}</div>
            </div>
          )}
          {values.email && (
            <div className={'descriptionBlock'}>
              <div className={'descriptionTitle'}>Email</div>
              <div className={'descriptionValue'}>{values.email}</div>
            </div>
          )}
          {values.mobilePhoneNumber && (
            <div className={'descriptionBlock'}>
              <div className={'descriptionTitle'}>{t('Mobile')}</div>
              <div className={'descriptionValue'}>{values.mobilePhoneNumber}</div>
            </div>
          )}
        </div>
        {values.nameOfHost && (
          <div className={'confirmQuestion'}>
            <div className={'confirmText'}>{t('Are you visiting')}</div>
            <div className={'confirmText'}>{values.nameOfHost}?</div>
          </div>
        )}
        <div className="flex items-center justify-between">
          <div onClick={onPrevClick} className={'buttonNo bg-blue-500 hover:bg-blue-700 font-bold focus:outline-none focus:shadow-outline'}>
            {t('No')}
          </div>
          <button
            type="submit"
            value="Submit"
            className="buttonYes bg-blue-500 hover:bg-blue-700 font-bold focus:outline-none focus:shadow-outline"
            disabled={isSubmitting}
          >
            {isSubmitting ? t('Submitting') : t('Yes')}
          </button>
        </div>
      </div>
      {/* 
      <div className={'paginationButtons'}>
        {selectedStage > 0 && selectedStage !== paginationMax && (
          <div onClick={onPrevClick} id={'buttonPrev'} className={'buttonPagination paginationPrev'}>
            {'< ' + t('Prev')}
          </div>
        )}
        {selectedStage > 0 && selectedStage < paginationMax && (
          <div
            onClick={(e) => {
              e.preventDefault();
              // console.log('aaaa', touched, errors);
              const isErrors = !isEmpty(compact(map(touched, (_value, key) => errors[key] && key)));
              if (isErrors) {
                return;
              }
              onNextClick();
            }}
            id={'buttonNext'}
            className={'buttonPagination paginationNext'}
          >
            {t('Next') + ' >'}
          </div>
        )}
      </div> */}
    </>
  );
}
